<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Histórico do paciente {{historico.data[0] ? historico.data[0].solicitacao.paciente.nome : ''}}</b>
						</h3>
					</div>
					<div class="box-body">
						<label for="">Histórico do sistema novo</label>
						<table class="table table-bordered table-striped">
							<thead>
								<tr>
									<th>Situação</th>
									<th>Unidade realizadora</th>
									<th>Data da realização</th>
									<th>Prof. Realizador</th>
									<th>Procedimento</th>
									<th>Solicitado em</th>
									<th>Unidade solicitante</th>
									<th>Prof. Solicitante</th>
									<th>Prof. Marcador</th>
								</tr>
							</thead>
							<tbody>
								<tr class="even" role="row" v-for="(item, index) in historico.data" :key="index">
									<td>{{item.solicitacao.situacao | situacaoSolicitacao}}</td>
									<td>{{item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome}}</td>
									<td>{{item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento | dataFormatada}}</td>
									<td>{{item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"}}</td>
									<td>{{item.contrato_procedimento.procedimento.nome}}</td>
									<td>{{item.solicitacao.created_at | dataFormatada}}</td>
									<td>{{item.contrato_procedimento.contrato.unidade.nome}}</td>
									<td>{{item.solicitacao.profissional.nome}}</td>
									<td>{{item.solicitacao.usuario.name}}</td>
								</tr>
							</tbody>
						</table>
						<br>
						<div class="row">
							<div class='col-sm-5'>
								Mostrando {{ this.historico.from }} até {{ this.historico.to }} de {{ this.historico.total }} registros encontrados.
							</div>
							<div class='col-sm-7' style="text-align:right">
								<laravue-pagination :limit="7" :data="historico" v-on:pagination-change-page="getHistorico">
									<span slot="prev-nav">&lt; Anterior</span>
									<span slot="next-nav">Próximo &gt;</span>
								</laravue-pagination>
							</div>
						</div>
						<br>
						<label for="">Histórico importado da base de dados anterior</label>
						<table class="table table-bordered table-striped">
							<thead>
								<tr>
									<th>Situação</th>
									<th>Unidade realizadora</th>
									<th>Data da realização</th>
									<th>Prof. Realizador</th>
									<th>Procedimento</th>
									<th>Solicitado em</th>
									<th>Unidade solicitante</th>
									<th>Prof. Solicitante</th>
									<th>Prof. Marcador</th>
								</tr>
							</thead>
							<tbody>
								<tr class="even" role="row" v-for="(item, index) in historicoAntigo.data" :key="index">
									<td>{{ item.situacao | situacaoSolicitacaoAntiga }}</td>
									<td>{{ item.unidade_realizadora }}</td>
									<td>{{ item.data_realizacao | dataFormatada }}</td>
									<td>{{ item.profissional_realizador }}</td>
									<td>{{ item.procedimento }}</td>
									<td>{{ item.data_solicitacao | dataFormatada }}</td>
									<td>{{ item.unidade_solicitante }}</td>
									<td>{{ item.profissional_solicitante}}</td>
									<td>{{ item.profissional_marcador}}</td>
								</tr>
							</tbody>
						</table>
						<br>
						<div class="row">
							<div class='col-sm-5'>
								Mostrando {{ this.historicoAntigo.from }} até {{ this.historicoAntigo.to }} de {{ this.historicoAntigo.total }} registros encontrados.
							</div>
							<div class='col-sm-7' style="text-align:right">
								<laravue-pagination :limit="7" :data="historicoAntigo" v-on:pagination-change-page="getHistoricoAntigo">
									<span slot="prev-nav">&lt; Anterior</span>
									<span slot="next-nav">Próximo &gt;</span>
								</laravue-pagination>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<button @click="$router.go(-1)" class="btn btn-default"><span class="fa fa-reply"></span> Voltar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios' // Cliente para requisição http

	export default {
		data: () => ({
			historico: {
				data: []
			},
			historicoAntigo: {}
		}),
		mounted() {
			this.getHistorico();
			this.getHistoricoAntigo();
		},
		methods: {
			getHistorico(page) {
				if (typeof page === 'undefined') {
					page = 1;
				}

				let config = this.$store.getters.getHeaderAuth;
				config.params = {
					page: page,
				};

				axios.get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getHistorico/` + this.$route.params.pacienteId, config)
					.then(response => {
						this.historico = response.data;
					}).catch((error) => {
						console.log(error);
					});
			},
			getHistoricoAntigo(page) {
				if (typeof page === 'undefined') {
					page = 1;
				}

				let config = this.$store.getters.getHeaderAuth;
				config.params = {
					page: page,
				};

				axios.get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getHistoricoAntigo/` + this.$route.params.pacienteId, config)
					.then(response => {
						this.historicoAntigo = response.data;
					}).catch((error) => {
						console.log(error);
					});
			},
			situacao(item) {
				switch (item.st_solicitacao) {
					case 1:
						return 'EM ANALISE';
					case 2:
						return 'APROVADA';
					case 3:
						return 'CONFIRMADA';
					case 4:
						return 'NEGADA';
					case 5:
						return 'EM PERÍCIA';
					case 6:
						return 'CANCELADA';
					case 7:
						return 'REALIZADA';
					case 8:
						return 'FALTA';
					case 9:
						return 'EM SUPERVISÃO';
					case 10:
						return 'SUPERVISIONADO';
					case 11:
						return 'EM EXTRAPOLACAO';
					case 12:
						return 'TFD';
					case 18:
						return 'FALTA AUTOMÁTICA';
				}
			}
		},
		watch: {

		},
		components: {}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// historico.vue?3caab38e